
import {  fetchTimeInterval, getCurrentTime, isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";

const TB_PPD_ACTIVITY_NAMES = new Set([
    'Screening - TB Screening (PPD)',
    'TB Screening (PPD)',
]);

export const isTbPpdScreeningActivity = (activityName = '') => {
    if (!activityName || typeof activityName !== 'string') return false;
    if (TB_PPD_ACTIVITY_NAMES.has(activityName.trim())) return true;
    const n = activityName.trim();
    return n.includes('PPD') && (n.includes('TB Screening') || n.includes('TB screening'));
};
const tBScreeningPPDActivityDetailsData = (props) => {
    const tbQuestionLayout = {
        layout: 'stacked',
        showContainerBorder: false,
        labelWrap: false,
    };
    return [
        {
            label: 'TB Placement Details',
            fields: [
                {
                    label: 'LOT Number',
                    col: 'col-md-6 border-0',
                    type: 'TextInput',
                    Max:191,
                    placeholder: 'LOT Number',
                    name: 'ppd_lot_number',
                    id: 'ppd_lot_number',
                    ...tbQuestionLayout,
                },
                {
                    label: 'NDC Number',
                    col: 'col-md-6 border-0',
                    type: 'TextInput',
                    Max:191,
                    placeholder: 'NDC Number',
                    name: 'ppd_ndc_number',
                    id: 'ppd_ndc_number',
                    ...tbQuestionLayout,
                },
                {
                    label: 'Placement Site',
                    col: 'col-md-6 border-0',
                    type: 'SelectList',
                    placeholder: 'Placement Site',
                    name: 'ppd_placement_site',
                    id: 'ppd_placement_site',
                    options:  optionsToKeyValuePairs(
                        ['Left Forearm', 'Right Forearm', 'Left Arm', 'Right Arm'],
                    
                    ),
                    ...tbQuestionLayout,
                },
                {
                    label: 'Placement Time',
                    col: 'col-md-6 border-0 ',
                    name: 'ppd_placement_time',
                    type: "SelectSearchList",
                    placeholder:'Time',
                    isAsync:true,
                    options:[{'label':getCurrentTime(),value:getCurrentTime()}],
                    loadCallBack:(val,callback)=>fetchTimeInterval(val,callback),
                    ...tbQuestionLayout,
                },
            ],
        },
        {
            label: 'TB Screening Questions',
            fields: [
                {
                    label: 'Previous positive TB test?',
                    col: 'col-12 border-0',
                    type: 'RadioGroup',
                    name: 'ppd_q_previous_positive_tb_test',
                    id: 'ppd_q_previous_positive_tb_test',
                    options: [
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" },
                    ],
                },
                {
                    label: 'Prior TB exposure?',
                    col: 'col-12 border-0',
                    type: 'RadioGroup',
                    name: 'ppd_q_prior_tb_exposure',
                    id: 'ppd_q_prior_tb_exposure',
                    options: [
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" },
                    ],
                },
                {
                    label: 'Persistent cough greater than 2 weeks?',
                    col: 'col-12 border-0',
                    type: 'RadioGroup',
                    name: 'ppd_q_persistent_cough_gt_2wk',
                    id: 'ppd_q_persistent_cough_gt_2wk',
                    options: [
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" },
                    ],
                },
                {
                    label: 'Fever, night sweats, or unexplained weight loss?',
                    col: 'col-12 border-0',
                    type: 'RadioGroup',
                    name: 'ppd_q_fever_night_sweats_weight_loss',
                    id: 'ppd_q_fever_night_sweats_weight_loss',
                    options: [
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" },
                    ],
                },
                {
                    label: 'Received BCG vaccine?',
                    col: 'col-12 border-0',
                    type: 'RadioGroup',
                    name: 'ppd_q_received_bcg',
                    id: 'ppd_q_received_bcg',
                    options: [
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" },
                    ],
                },
            ],
        },
        {
            label: 'Activity Details - ' + props.activityName,
            fields: [
                {
                    label: 'Notes',
                    ...tbQuestionLayout,
                    col: 'col-12 border-0',
                    placeholder: 'Notes',
                    type: 'TextArea',
                    name: 'notes',
                },
            ],
        },
        {
            label: 'Review / Completion',
            fields: [
                {
                    type: 'ProviderSignOff',
                    col: 'col-12',
                    fields: [
                        { label: 'Signature PIN', name: 'provider_pin', col: 'col-12' },
                        { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
                        { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                        {
                            label : "Final Results",
                            type: "SelectList",
                            name: "status",
                            col: "col-12",
                            options: optionsToKeyValuePairs(
                                [
                                    "Not Started",
                                    "Pending",
                                    "Normal",
                                    "Abnormal",
                                    "Negative",
                                    "Positive",
                                    "Dispensed",
                                    "Administered",
                                    "Failed",
                                    "Passed",
                                    "Non-Negative",
                                    "Cancelled",
                                    "Inconclusive",
                                ],
                                false
                            ),
                            statusBasedColor: true,
                        },
                        {
                            label : "Activity Status",
                            type: "SelectList",
                            name: "activity_status",
                            col: "col-12",
                            options: optionsToKeyValuePairs(
                                [
                                    "Not Started",
                                    "Pending",
                                    "Pending Lab Confirmation",
                                    "Pending MRO Confirmation",
                                    "Ready for Review",
                                    "Completed",
                                    "Cancelled",
                                ],
                                false
                            ),
                            statusBasedColor: true,
                        },
                    ],
                },
            ],
        },
    ];
};
export const ScreeningLadderClimb = (props)=>{
    const {activityName} = props;
    const isTbPpd = isTbPpdScreeningActivity(activityName);
    let appendCharts = [];
    if(activityName==='Screening - EKG'){
        appendCharts = [{
            type:'Tab',
            col:'col-md-9',
            data:[
                {
                    id:'activity_details',
                    label:'Activity Details',
                    data:[
                        {
                            label:'Activity Details - '+props.activityName,
                            fields:[{
                                label:'EKG',
                                col:'col-6',
                                type:'SelectList',
                                name:'screening_ekg',
                                id:'screening_ekg',
                                options:optionsToKeyValuePairs(['Abnormal','Normal','Incidental Finding - Referred to PCP','Abnormal - Referred to PCP']),
                            },
                            {
                                label:'Suggested Result',
                                disabled:true,
                                type:'TextInput',
                                disabled:true,
                                options:isSet(props.lookupsOptions['chartResult'],[]),
                                name:'suggested_status',
                            },
                            {
                                label:'Notes',
                                col:'col-6',
                                type:'TextArea',
                                placeholder: 'Notes',
                                name:'notes',
                            },
                            {
                                label:'Final Determination',
                                type:'SelectList',
                                options:isSet(props.lookupsOptions['chartResult'],[]),
                                name:'status',
                            },
                            
                           
                        ]
                        }
                    ]
                },
                {
                    id:'Images',
                    label:'Images',
                    data:[]
                }
            ]
        }]
    }else if (isTbPpd) {
        appendCharts = [{
            type:'Tab',
            col:'col-md-9',
            data:[
                {
                    id:'activity_details',
                    label:'Activity Details',
                    data: tBScreeningPPDActivityDetailsData(props),
                },
                {
                    id:'Images',
                    label:'Images',
                    data:[]
                }
            ]
        }]
    }else{
        appendCharts = [{
            type:'Tab',
            col:'col-md-9',
            data:[
                {
                    id:'activity_details',
                    label:'Activity Details',
                    data:[
                        {
                            label:'Activity Details - '+props.activityName,
                            fields:[
                            
                            {
                                label:'Notes',
                                placeholder: 'Notes',
                                col:'col-12',
                                type:'TextArea',
                                name:'notes',
                            },
                            
                           
                            ]   
                        },
                        {
                            label: 'Review / Completion',
                            fields: [
                                {
                                    type: 'ProviderSignOff',
                                    col: 'col-12',
                                    fields: [
                                        { label: 'Signature PIN', name: 'provider_pin', col: 'col-12' },
                                        { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
                                        { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                                        {
                                            label : "Final Results",
                                            type: "SelectList",
                                            name: "status",
                                            col: "col-12",
                                            options: optionsToKeyValuePairs(
                                                [
                                                    "Not Started",
                                                    "Pending",
                                                    "Normal",
                                                    "Abnormal",
                                                    "Negative",
                                                    "Positive",
                                                    "Dispensed",
                                                    "Administered",
                                                    "Failed",
                                                    "Passed",
                                                    "Non-Negative",
                                                    "Cancelled",
                                                    "Inconclusive",
                                                ],
                                                false
                                            ),
                                            statusBasedColor: true,
                                        },
                                        {
                                            label : "Activity Status",
                                            type: "SelectList",
                                            name: "activity_status",
                                            col: "col-12",
                                            options: optionsToKeyValuePairs(
                                                [
                                                    "Not Started",
                                                    "Pending",
                                                    "Pending Lab Confirmation",
                                                    "Pending MRO Confirmation",
                                                    "Ready for Review",
                                                    "Completed",
                                                    "Cancelled",
                                                ],
                                                false
                                            ),
                                            statusBasedColor: true,
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    id:'Images',
                    label:'Images',
                    data:[]
                }
            ]
        }]
    }
    const charts = [{
        type:'Grid',
        col:'col-md-3',
        data:[{
            type:"PatientDetails",
            employeeDetails:props.employeeDetails,
            visitDetails:props.visitDetails
        },{
            type:"CompanyDetails",
            companyDetails:props.companyDetails
        }],
    },...appendCharts];
    const defaultValue = {
        status:'Not Started',
        suggested_status:'Not Started',
        activity_status:'Not Started',
        // reason:'Pre-employment'
    };
    const headers = [{
        type: 'Tab',
        data: [
            {
                label: 'Activity Details',
                id: 'activity_details'
            },
            {
                label: 'Images',
                id: 'Images'
            }
        ]
    }];
    return {
        charts,
        defaultValue,
        headers,
        computationFunction: (formData,key) => ({
            // ...computationRules(formData,key),
            ...computationRules1(formData,key),
        }),
    };
}


const computationRules = (formData,key)=>{

    const screeningEkg = isSet(formData.screening_ekg,'');
    let status = 'Not Started';
    let activity_status = formData.activity_status;
    if(screeningEkg===''){
     status = 'Pending';
     activity_status = 'Pending';   
    }else if (screeningEkg==='Abnormal') {
         status = 'Failed';
         activity_status = 'Completed';
     } else{
         status = 'Passed';
         activity_status = 'Completed';
     }
     let statusUpdateExcludeKeys=['notes']; // status update for some fileds exculdes
     if (statusUpdateExcludeKeys.includes(key)) {
       return {}; 
     }
     return (key==='status' || key==='activity_status')?{}:{'status':status,'suggested_status':status,'activity_status':activity_status};
}